const SahayakLogo = "/VRSamadhanSahayak.png";

export default function WelcomeScreen() {
	return (
		<div className="flex-1 flex flex-col items-center justify-center text-gray-500">
			<img
				src={SahayakLogo}
				alt="VRSamadhan Sahayak"
				className="w-40 mb-6 opacity-100"
			/>

			<div className="text-xl font-semibold text-gray-700 mb-2">
				Welcome to VRSamadhan Sahayak
			</div>

			<div className="text-sm text-gray-500">
				Select a chat to start messaging
			</div>
		</div>
	);
}
